import { Ionicons } from "@expo/vector-icons";
import React, { useEffect, useState } from "react";
import {
  Alert,
  Dimensions,
  ScrollView,
  Text,
  View,
  StyleSheet,
  Platform,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Centered,
  Loading,
  Row,
  ModalButtons,
  Modal,
} from "../../../components/all";
import { WebView } from "react-native-webview";
import { normalize } from "../../../utils/normalize";
import Styles from "../../../constants/styles";
import { setDocsUploaded } from "../../../reducers/auth/user";
import { setFreshRegister } from "../../../reducers/profile/profile";
import { addFields } from "../../../reducers/auth/register";
import { setUserToken } from "../../../reducers/auth/user";
import { register, requestOTP } from "../../../services/auth";
import { PLACEHOLDER_PROFILE_BASE64 } from "../../../constants/placeholderImage";

Object.map = function (o, f, ctx) {
  ctx = ctx || this;
  var result = {};
  Object.keys(o).forEach(function (k) {
    result[k] = f.call(ctx, o[k], k, o);
  });
  return result;
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function Step4({ editProfile, navigation }) {
  const safeInsets = useSafeAreaInsets();

  const dispatch = useDispatch();
  const { fields, errorFields } = useSelector((state) => state.register);
  const { isDoctor, country } = useSelector((state) => state.user);
  useEffect(() => {
    dispatch(setDocsUploaded(false));
  }, []);
  const INJECTED_JAVASCRIPT = `document.addEventListener("click", function(){
    setTimeout(() => {
      let bodyHTML = document.body.innerHTML;
      window.ReactNativeWebView.postMessage(JSON.stringify(bodyHTML));
    }, 2000)


  });`;
  const [verifying, setVerifying] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSubmitConfirmModal, setShowSubmitConfirmModal] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const name = fields.first_name + "+" + fields.last_name;
  const getLink = () => {
    let url = "";
    if (fields.expertise > 500 && fields.expertise < 600) {
      url = "appxaVqqNjeHyOoKz/shrdJqUcjOgFkrj0o";
    } else {
      url = fields?.nsr ? `shrW39tnb9YghKdTy` : `shrVz3Kn8iZVhT8nF`;
    }
    return airtableURL + url + `?prefill_Name=${name}`;
  };
  const airtableURL =
    Platform.OS === "web"
      ? "https://airtable.com/embed/"
      : "https://airtable.com/";
  const links = {
    doctorTerms: getLink(),
    clinicTerms:
      airtableURL +
      `shrrnHBt7prAoSYj3?prefill_Clinic+Name=${fields.clinic_name}`,
  };

  const registerUser = useMutation(register, {
    onError: (error) => {
      setVerifying(false);
      let formattedError = "";
      Object.map(error.response.data.errors, (v, k) => {
        let errorMessage = v.join("\n");
        formattedError += `\n- ${errorMessage}`;
      });
      Alert.alert("Registration Error", formattedError);
    },
    onSuccess: (data) => {
      dispatch(setUserToken(data.data.token));
      sendOTP.mutate({
        email: fields.email,
      });
    },
  });

  const sendOTP = useMutation(requestOTP, {
    onError: (error) => {
      setVerifying(false);
      alert("Oops! " + error.response.data.message);
    },
    onSuccess: (res) => {
      setVerifying(false);
      dispatch(setFreshRegister(true));
      dispatch(addFields({ ...fields, nonce: res.data.data.nonce }));
      navigation.navigate("ValidateOTPScreen");
    },
  });

  const submitFields = () => {
    setVerifying(true);
    let extraParams = {};
    if (isDoctor) {
      extraParams = {
        scope: "doctor",
        about: fields.about,
        nric_passport_number: fields.nric_passport_number,
        apc: fields.apc,
        mmc: fields.mmc,
        nsr: fields.nsr,
        expertise: fields.expertise,
      };
    } else {
      extraParams = {
        scope: "clinic_owner",
        clinic_phone_number: fields.clinic_phone_number,
        clinic_name: fields.clinic_name,
        business_registration_number: fields.business_registration_number,
        clinic_profile_image:
          fields?.clinic_profile_image || PLACEHOLDER_PROFILE_BASE64,
        longitude: fields.longitude?.toFixed(5),
        latitude: fields.latitude?.toFixed(5),
        facilities: ["doctor-gp-general-practitioner"],
      };
    }

    registerUser.mutate({
      email: fields.email,
      password: fields.password,
      first_name: fields.first_name,
      last_name: "-",
      phone_number: fields.phone_number,
      address: fields.address,
      city: fields.city,
      state: fields.state,
      postcode: fields.postcode,
      country: country || "MY", // Include country from Redux
      emergency_name: fields.emergency_name,
      emergency_number: fields.emergency_number,
      profile_image: fields?.profile_image || PLACEHOLDER_PROFILE_BASE64,
      education: fields.education,
      facilities: fields.facilities,
      ...extraParams,
    });
  };

  return (
    <>
      <View
        style={{
          ...Styles.webSmallContainer,
          marginTop: 40,
        }}
      >
        <>
          <ScrollView
            contentContainerStyle={{
              width: "100%",
              height: Dimensions.get("window").height - 180,
            }}
          >
            {isLoading && (
              <View style={{ marginTop: 100 }}>
                <ActivityIndicator size="large" />
              </View>
            )}
            {Platform.OS === "web" ? (
              <iframe
                src={isDoctor ? links.doctorTerms : links.clinicTerms}
                height={"100%"}
                width={"100%"}
                style={{
                  borderWidth: 0,
                  height: Dimensions.get("window").height - safeInsets.top,
                }}
              />
            ) : (
              <WebView
                source={{
                  uri: isDoctor ? links.doctorTerms : links.clinicTerms,
                }}
                onLoadStart={() => {
                  setIsLoading(true);
                }}
                onLoadEnd={() => {
                  setIsLoading(false);
                }}
                injectedJavaScript={INJECTED_JAVASCRIPT}
                javaScriptEnabled={true}
                originWhitelist={["*"]}
                scalesPageToFit={true}
                onMessage={(event) => {
                  let innerHTML = event.nativeEvent.data;
                  if (innerHTML.includes("Now create your own form")) {
                    dispatch(setDocsUploaded(true));
                    setIsFileUploaded(true);
                  }
                }}
              />
            )}
          </ScrollView>
        </>
      </View>
      <View
        style={{
          paddingBottom: safeInsets.bottom,
          ...styles.termsContainer,
        }}
      >
        <Centered style={{ marginBottom: 24 }}>
          <Row>
            <Button
              label="Back"
              type={"secondary"}
              onPress={() => {
                navigation.goBack();
              }}
            />
            <Button
              label="Next"
              type={"primary"}
              onPress={() => {
                if (Platform.OS === "web") {
                  setShowSubmitConfirmModal(true);
                } else if (isFileUploaded) {
                  setShowSubmitConfirmModal(true);
                } else {
                  setShowConfirmModal(true);
                }
              }}
            />
          </Row>
          <TouchableOpacity
            onPress={() => {
              setShowSubmitConfirmModal(true);
            }}
          >
            <Text style={{ color: "grey", marginTop: 8 }}>Skip for now</Text>
          </TouchableOpacity>
        </Centered>
      </View>
      <Modal
        isVisible={showConfirmModal}
        onBackdropPress={() => setShowConfirmModal(false)}
      >
        <View style={{ alignItems: "center", marginBottom: 12 }}>
          <Ionicons name="alert-circle-outline" size={24} color="#FF4B4B" />
        </View>
        <Text
          style={{
            fontWeight: "bold",
            fontSize: normalize(16),
            textAlign: "center",
          }}
        >
          File Not Uploaded
        </Text>
        <Text
          style={{
            textAlign: "center",
            marginTop: 10,
            marginBottom: 24,
            marginHorizontal: 24,
          }}
        >
          Please upload your documents to complete your registration.
        </Text>
        <ModalButtons
          onCancel={() => setShowConfirmModal(false)}
          onConfirm={() => {
            setShowConfirmModal(false);
            // submitFields();
          }}
        />
      </Modal>

      <Modal
        isVisible={showSubmitConfirmModal}
        onBackdropPress={() => setShowSubmitConfirmModal(false)}
      >
        <View style={{ alignItems: "center", marginBottom: 12 }}>
          <Ionicons name="alert-circle-outline" size={24} color="#FF4B4B" />
        </View>
        <Text
          style={{
            fontWeight: "bold",
            fontSize: normalize(16),
            textAlign: "center",
          }}
        >
          Complete Registration
        </Text>
        <Text
          style={{
            textAlign: "center",
            marginTop: 10,
            marginBottom: 24,
            marginHorizontal: 24,
          }}
        >
          Please double check the fields before submitting, a verification will
          be sent to your email.
        </Text>
        <ModalButtons
          onCancel={() => setShowSubmitConfirmModal(false)}
          onConfirm={() => {
            setShowSubmitConfirmModal(false);
            submitFields();
          }}
        />
      </Modal>
      <Loading visible={verifying && Platform.OS !== "web"} />
    </>
  );
}

const styles = StyleSheet.create({
  termsContainer: {
    paddingTop: 24,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
  },
});
